import { render, staticRenderFns } from "./carCreateFeeList.vue?vue&type=template&id=5fa399a2&scoped=true"
import script from "./carCreateFeeList.vue?vue&type=script&lang=js"
export * from "./carCreateFeeList.vue?vue&type=script&lang=js"
import style0 from "./carCreateFeeList.vue?vue&type=style&index=0&id=5fa399a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa399a2",
  null
  
)

export default component.exports